/* EBH 2026-11-02 · a linha das medidas e a aba PRODUCT INFO acompanham a variante.
   As duas são desenhadas pelo Liquid UMA vez, com a variante da primeira visita;
   o tema muda o preço e o ?variant= ao escolher outro tamanho, mas não volta a
   desenhar o que é nosso. Nos Confetti Jars (listagem combinada 15 + 22 cm)
   escolher «Big» deixava «Ø 11 cm · H 15 cm» à vista.
   Aqui: quando a variante muda, pede-se ao tema SÓ a secção do produto com a
   variante nova (Section Rendering API) e trocam-se as duas peças. O servidor
   já as desenha certas para qualquer ?variant= — é a mesma conta, sem cópia. */
(function () {
  if (window.__ebhFichaVariante) return;
  window.__ebhFichaVariante = true;

  var PECAS = ['.ebh-dims-wrap', '.ebh-tab'];
  var seccao = document.querySelector('[id^="shopify-section-"][id$="__main"]');
  if (!seccao) return;
  var idSeccao = seccao.id.replace('shopify-section-', '');

  function varianteAtual() {
    var p = new URLSearchParams(location.search).get('variant');
    if (p) return p;
    var i = seccao.querySelector('form[action*="/cart/add"] [name="id"]');
    return i ? i.value : null;
  }

  var ultima = varianteAtual();
  var pedido = 0;

  function refrescar() {
    var v = varianteAtual();
    if (!v || v === ultima) return;
    ultima = v;
    var meu = ++pedido;
    var u = new URL(location.href);
    u.searchParams.set('variant', v);
    u.searchParams.set('section_id', idSeccao);
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (meu !== pedido) return;            // chegou outro pedido entretanto
        var novo = new DOMParser().parseFromString(html, 'text/html');
        PECAS.forEach(function (sel) {
          var velhos = document.querySelectorAll(sel);
          var novos = novo.querySelectorAll(sel);
          velhos.forEach(function (el, n) { if (novos[n]) el.replaceWith(novos[n]); });
        });
        /* as polegadas da aba vêm de um <script> do próprio snippet, que só corre
           quando a página abre: volta a correr-se o da secção nova */
        novo.querySelectorAll('script:not([src])').forEach(function (s) {
          if (s.textContent.indexOf('CM_TO_IN') === -1) return;
          var corre = document.createElement('script');
          corre.textContent = s.textContent;
          document.body.appendChild(corre);
          corre.remove();
        });
      })
      .catch(function () { ultima = null; });  // na próxima mudança tenta outra vez
  }

  /* o tema troca o ?variant= com replaceState — é o sinal mais fiel */
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () {
      var r = orig.apply(this, arguments);
      setTimeout(refrescar, 0);
      return r;
    };
  });
  window.addEventListener('popstate', refrescar);
  document.addEventListener('change', function () { setTimeout(refrescar, 60); }, true);
})();
